<template>
  <v-layout
    wrap
    class="formatted-text"
  >
    <v-flex
      md4
      class="pr-3"
    >
      <h3 class="display-2">
        {{ title }}
      </h3>
      <slot name="notes" />
    </v-flex>
    <v-flex md8>
      <v-layout wrap>
        <v-flex
          v-for="(item, index) in items"
          :key="index"
          :md6="!isClothes"
          :md12="isClothes"
        >
          <v-layout
            v-if="isClothes"
            wrap
          >
            <v-flex
              v-for="(product, index) in item.chosenList"
              :key="index"
              md6
            >
              <v-checkbox
                disabled
                class="mt-0 pt-0 mb-2"
              >
                <template slot="label">
                  <v-layout
                    align-center
                    wrap
                  >
                    <v-flex xs12>
                      <span class="fw-600">{{ item.newName | addColons }}</span>
                      {{ product.category }}
                      <span v-if="hasProp(product, 'type')">{{ product.type | brackets }}</span>
                    </v-flex>
                    <v-flex
                      xs12
                      class="f-05"
                    >
                      {{ $t('sheet.sheet_two.clothing.labels.size') | addColons }}
                      {{ product.size }}
                      <span v-if="product.note !== null">{{ $t('sheet.sheet_two.clothing.labels.note') | addColons }}
                        {{ product.note }}</span>
                    </v-flex>
                  </v-layout>
                </template>
              </v-checkbox>
            </v-flex>
          </v-layout>
          <v-checkbox
            v-else
            disabled
            class="mt-0 pt-0 mb-2"
            :label="item"
          >
            <template slot="label">
              <slot
                v-if="item === 'Opał'"
                name="fuelInfo"
              />
              <span v-else>{{ item }}</span>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      v-if="showDivider"
      xs12
    >
      <v-divider class="my-4" />
    </v-flex>
  </v-layout>
</template>

<script>
import filters from '@/constants/filters';
import has from 'lodash.has';

export default {
    name: 'FamilyNeedsItem',
    filters: {
        ...filters
    },
    props: {
        title: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        showDivider: {
            type: Boolean,
            default: true
        },
        isClothes: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        hasProp (obj, prop) {
            return has(obj, prop);
        }
    }
};
</script>

<style scoped></style>
